import { DocsSidebarFragment } from 'components/docs/docs-sidebar-fragment';
import sections from 'pages/_meta.json';

const DocsSidebarBody = ({ onNavigate }: { onNavigate?: () => void }) => (
	<DocsSidebarFragment sections={sections} onNavigate={onNavigate} />
);

export { DocsSidebarBody };
